export default {"src":"/_next/static/media/star-white.5fc8c879.svg","height":13,"width":14,"blurWidth":0,"blurHeight":0};